import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { getLocale } from "./common/utils";
i18n.use(HttpApi)
    .use(initReactI18next)
    .init({
        debug: false,
        // debug: process.env.NODE_ENV === "development",
        lng: getLocale(),
        backend: {
            loadPath:
                ENV === "local"
                    ? "/locales/{{lng}}.json"
                    : "/assets/preferences-portal/locales/{{lng}}.json",
        },
        nsSeparator: "::",
        keySeparator: false,
        lowerCaseLng: true,
        load: "currentOnly",
        fallbackLng: "en-us",
        react: {
            wait: false,
            bindI18n: "languageChanged loaded",
            bindStore: "added removed",
            nsMode: "default",
        },
    });

//dummy function t for extracting dynamic text for scanner
const t = () => {};

const dynamicStrings = [
    t("Gaming & entertainment"),
    t("Enterprise"),
    t("Developer"),
    t("Gaming Hardware"),
    t("NVIDIA SHIELD"),
    t("Games"),
    t("Drivers"),
    t("eSports"),
    t("Virtual Reality"),
    t("NVIDIA Studio"),
    t("GeForce NOW"),
    t("AR / VR"),
    t("Computer Vision / Video Analytics"),
    t("Cybersecurity / Fraud Detection"),
    t("Data Science"),
    t("Rendering / Ray Tracing"),
    t("Simulation / Modeling / Design"),
    t("Networking"),
    t("Data Center / Cloud"),
    t("Edge Computing"),
    t("Conversational AI / NLP"),
    t("Recommenders / Personalization"),
    t("Robotics"),
    t("Video Streaming / Conferencing"),
    t("Virtualization"),
    t("Other"),
    t("Generative AI"),
    t("Game Engines"),

    t("Which gaming & entertainment topics interest you the most?"),
    t("Which enterprise & developer topics interest you the most?"),

    t("Yes, send me gaming and entertainment deals, announcements, and more from NVIDIA."),
    t("Yes, send me the latest enterprise news, announcements, and more from NVIDIA."),
    t("Yes, send me the latest developer news, announcements, and more from NVIDIA."),

    t(
        "Get the latest updates on GeForce GTX products including graphics cards, laptops, and systems."
    ),
    t(
        "Stay current with SHIELD's newest updates, from added features to the latest apps and games."
    ),
    t("Find out about all the latest PC titles and great gaming bundles."),
    t(
        "Get notified when Game Ready Drivers for gaming and NVIDIA Studio Drivers for creative apps are ready to install."
    ),
    t(
        "See how NVIDIA is supporting and powering the communities that are shaping this incredible phenomenon."
    ),
    t(
        "Discover how NVIDIA is creating and powering more immersive experiences for gaming and beyond."
    ),
    t(
        "Sign up for creative app tutorials and news on the latest Studio products to supercharge your creative work."
    ),
    t(
        "Subscribe for GFN game updates and exclusive rewards on the premiere Cloud Gaming platform."
    ),
    t(
        "Discover how to integrate AR and VR in your applications to drive design reviews, virtual production, location-based entertainment, and more."
    ),
    t(
        "Empower your devices to perceive and understand the world around us with powerful software that’s masterful, scalable, and tested."
    ),
    t(
        "Learn about AI solutions to identify, capture and take action on threats and anomalies that were previously impossible to identify."
    ),
    t(
        "See how you can accelerate your end-to-end data science and analytics pipelines with NVIDIA technologies."
    ),
    t(
        "Explore how NVIDIA technologies work together to produce the next generation of stunning real-time graphics."
    ),
    t(
        "Explore accelerated networking in NVIDIA-Certified Systems, from mainstream enterprise servers to high-performance supercomputers."
    ),
    t(
        "Learn about the technologies used to develop language based apps that allow humans to interact naturally with devices, machines, and computers using speech."
    ),
    t(
        "Get to know about the tools and techniques for building and deploying highly effective recommender systems."
    ),
    t(
        "Find out about the latest technologies for robotics and autonomous machines that will drive this exciting new era of smart embedded robotics."
    ),
    t(
        "Discover the latest innovations that are providing more realistic visualizations for professionals, creators and artists worldwide."
    ),
    t(
        "Learn about state-of-the-art AI features to develop virtual collaboration and content creation applications such as video conferencing and live streaming."
    ),
    t("Explore how you can run the most compute-intensive server workloads on virtual machines."),
    t("Explore how accelerated computing is transforming data centers to fast-forward innovation."),
    t(
        "Learn about the latest technologies for using AI to generate visual content, text and data."
    ),
    t(
        "Learn how to accelerate the development of your photorealistic visuals within the most popular real-time creation platforms."
    ),
    t("I'm no longer interested in receiving these emails."),
    t("I don't remember signing up to receive them."),
    t("The emails aren't relevant to me."),
    t("The emails are too long and/or not mobile-friendly."),
    t("I receive too much email from NVIDIA."),
    t("I receive too much email from everyone."),

    t("中文（简体）"),
    t("中文 (繁體)"),
    t("Čeština"),
    t("Dansk"),
    t("Nederlands"),
    t("Nederlands (België)"),
    t("English (Australia)"),
    t("English (GB)"),
    t("English (India)"),
    t("English (Malaysia)"),
    t("English (Philippines)"),
    t("English (Singapore)"),
    t("English (US)"),
    t("Suomi"),
    t("Français (France)"),
    t("Français (Belgique)"),
    t("Deutsch"),
    t("Deutsch (Österreich)"),
    t("Italiano"),
    t("Bahasa Indonesia"),
    t("日本語"),
    t("한국어"),
    t("Norsk"),
    t("polski"),
    t("Português (Brasil)"),
    t("русский"),
    t("Español (México)"),
    t("Español (Perú)"),
    t("Español (España)"),
    t("Svenska"),
    t("Türkçe"),
    t("Tiếng Việt"),
    t("ภาษาไทย"),

    t("Afghanistan"),
    t("Aland Islands"),
    t("Albania"),
    t("Algeria"),
    t("American Samoa"),
    t("Andorra"),
    t("Angola"),
    t("Anguilla"),
    t("Antarctica"),
    t("Antigua and Barbuda"),
    t("Argentina"),
    t("Armenia"),
    t("Aruba"),
    t("Australia"),
    t("Austria"),
    t("Azerbaijan"),
    t("Bahamas"),
    t("Bahrain"),
    t("Bangladesh"),
    t("Barbados"),
    t("Belarus"),
    t("Belgium"),
    t("Belize"),
    t("Benin"),
    t("Bermuda"),
    t("Bhutan"),
    t("Bolivia"),
    t("Bosnia and Herzegovina"),
    t("Botswana"),
    t("Bouvet Island"),
    t("Brazil"),
    t("British Indian Ocean Territory"),
    t("British Virgin Islands"),
    t("Brunei Darussalam"),
    t("Bulgaria"),
    t("Burkina Faso"),
    t("Burundi"),
    t("Cambodia"),
    t("Cameroon"),
    t("Canada"),
    t("Cape Verde"),
    t("Cayman Islands"),
    t("Central African Republic"),
    t("Chad"),
    t("Chile"),
    t("China"),
    t("Christmas Island"),
    t("Cocos (Keeling) Islands"),
    t("Colombia"),
    t("Comoros"),
    t("Congo"),
    t("Congo, Democratic Republic of the"),
    t("Cook Islands"),
    t("Costa Rica"),
    t("Cote D'Ivoire"),
    t("Croatia"),
    t("Cuba"),
    t("Curaao"),
    t("Cyprus"),
    t("Czech Republic"),
    t("Denmark"),
    t("Djibouti"),
    t("Dominica"),
    t("Dominican Republic"),
    t("Ecuador"),
    t("Egypt"),
    t("El Salvador"),
    t("Equatorial Guinea"),
    t("Eritrea"),
    t("Estonia"),
    t("Ethiopia"),
    t("Falkland Islands (Malvinas)"),
    t("Faroe Islands"),
    t("Fiji"),
    t("Finland"),
    t("France"),
    t("French Guiana"),
    t("French Polynesia"),
    t("French Southern Territories"),
    t("Gabon"),
    t("Gambia"),
    t("Georgia"),
    t("Germany"),
    t("Ghana"),
    t("Gibraltar"),
    t("Greece"),
    t("Greenland"),
    t("Grenada"),
    t("Guadeloupe"),
    t("Guam"),
    t("Guatemala"),
    t("Guernsey"),
    t("Guinea"),
    t("Guine"),
    t("Guyana"),
    t("Haiti"),
    t("Heard Island and Mcdonald Islands"),
    t("Honduras"),
    t("Hong Kong"),
    t("Hungary"),
    t("Iceland"),
    t("India"),
    t("Indonesia"),
    t("Iran"),
    t("Iraq"),
    t("Ireland"),
    t("Isle of Man"),
    t("Israel"),
    t("Italy"),
    t("Jamaica"),
    t("Japan"),
    t("Jersey"),
    t("Jordan"),
    t("Kazakhstan"),
    t("Kenya"),
    t("Kiribati"),
    t("Korea, Democratic People's Republic of"),
    t("Korea, Republic of"),
    t("Kuwait"),
    t("Kyrgyzstan"),
    t("Lao People's Democratic Republic"),
    t("Latvia"),
    t("Lebanon"),
    t("Lesotho"),
    t("Liberia"),
    t("Libya"),
    t("Liechtenstein"),
    t("Lithuania"),
    t("Luxembourg"),
    t("Macao"),
    t("Macedonia"),
    t("Madagascar"),
    t("Malawi"),
    t("Malaysia"),
    t("Maldives"),
    t("Mali"),
    t("Malta"),
    t("Marshall Islands"),
    t("Martinique"),
    t("Mauritania"),
    t("Mauritius"),
    t("Mayotte"),
    t("Mexico"),
    t("Micronesia, Federated States of"),
    t("Moldova, Republic of"),
    t("Monaco"),
    t("Mongolia"),
    t("Montenegro"),
    t("Montserrat"),
    t("Morocco"),
    t("Mozambique"),
    t("Myanmar"),
    t("Namibia"),
    t("Nauru"),
    t("Nepal"),
    t("Netherlands Antilles"),
    t("New Caledonia"),
    t("New Zealand"),
    t("Nicaragua"),
    t("Niger"),
    t("Nigeria"),
    t("Niue"),
    t("Norfolk Island"),
    t("Northern Mariana Islands"),
    t("Norway"),
    t("Oman"),
    t("Pakistan"),
    t("Palau"),
    t("Palestinian Territory, Occupied"),
    t("Panama"),
    t("Papua New Guinea"),
    t("Paraguay"),
    t("Peru"),
    t("Philippines"),
    t("Pitcairn"),
    t("Poland"),
    t("Portugal"),
    t("Puerto Rico"),
    t("Qatar"),
    t("Reunion"),
    t("Romania"),
    t("Russian Federation"),
    t("Rwanda"),
    t("Saint Helena"),
    t("Saint Kitts and Nevis"),
    t("Saint Lucia"),
    t("Saint Pierre and Miquelon"),
    t("Saint Vincent and the Grenadines"),
    t("Saint Barthélemy"),
    t("Sain"),
    t("Samoa"),
    t("San Marino"),
    t("Sao Tome and Principe"),
    t("Saudi Arabia"),
    t("Senegal"),
    t("Serbia"),
    t("Seychelles"),
    t("Sierra Leone"),
    t("Singapore"),
    t("Slovakia"),
    t("Slovenia"),
    t("Solomon Islands"),
    t("Somalia"),
    t("South Africa"),
    t("South Georgia and the South Sandwich Islands"),
    t("South Sudan"),
    t("Spain"),
    t("Sri Lanka"),
    t("Sudan"),
    t("Suriname"),
    t("Svalbard and Jan Mayen"),
    t("Swaziland"),
    t("Sweden"),
    t("Switzerland"),
    t("Syria"),
    t("Taiwan"),
    t("Tajikistan"),
    t("Tanzania"),
    t("Thailand"),
    t("The Netherlands"),
    t("Timo"),
    t("Togo"),
    t("Tokelau"),
    t("Tonga"),
    t("Trinidad and Tobago"),
    t("Tunisia"),
    t("Turkey"),
    t("Turkmenistan"),
    t("Turks and Caicos Islands"),
    t("Tuvalu"),
    t("Uganda"),
    t("Ukraine"),
    t("United Arab Emirates"),
    t("United Kingdom"),
    t("United States"),
    t("United States Minor Outlying Islands"),
    t("Uruguay"),
    t("Uzbekistan"),
    t("Vanuatu"),
    t("Vatican City State"),
    t("Venezuela"),
    t("Viet Nam"),
    t("Virgin Islands, U.S."),
    t("Wallis and Futuna"),
    t("Western Sahara"),
    t("Yemen"),
    t("Zambia"),
    t("Zimbabwe"),
    t("No preferences are associated with this email address. Click <lnk>here</lnk> to sign up."),
    t("Startup"),
    t("Yes, send me information about NVIDIA's support, news, and more, available for startups."),
    t("Interest-Based Ads"),
    t("Generative AI / LLMs"),
    t("Conversational AI"),
    t("Content Creation / Rendering"),
    t("Cybersecurity"),
    t(
        "Yes, {{SHARE_MY_DETAILS}} with third-party ad platforms so I can receive ads provided by NVIDIA that are more relevant to my interests."
    ),
    t(
        "Yes, {{SHARE_MY_DETAILS_NVIDIA_PLATFORMS}} with ad providers so the third-party ads on NVIDIA platforms are more relevant to my interests."
    ),
    t(
        "Users below the age of 16 are automatically opted out of interest-based ads regardless of this setting."
    ),
    t("NVIDIA Platforms"),
    t("Third Party Platforms"),
    t("Networking / Communications"),
    t("AI Platforms / Deployment"),
    t("Development & Optimization"),
    t("Models / Libraries / Frameworks"),
    t("MLOps"),
    t(
        "Learn about best practices for accelerated computing application development and performance optimization."
    ),
    t(
        "Learn how to build and apply models, libraries, and frameworks for use in accelerated applications."
    ),
    t("Learn about best practices for deploying and managing AI solutions at scale."),
    t(
        "Explore resources on MLOps, including best practices for automating, scaling, and operationalizing machine learning models in production environments."
    ),
    t("Trustworthy AI / Cybersecurity"),
    t("Agentic AI / Generative AI"),
    t("Developer Tools & Techniques"),
];

export default i18n;
